import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MsAuthService } from './ms-auth.service';
import { map, Observable, of } from 'rxjs';
export interface IMSGraphResponse {
  employeeId: string;
}

@Injectable({
  providedIn: 'root'
})
export class MsGraphService {
  private _baseUrl:string;
  constructor(
    private _httpClient: HttpClient,
    private _authService: MsAuthService,
  ) { 
    this._baseUrl = environment.azure.graphApi;
  }

  public getEmployeeId():Observable<IMSGraphResponse | null>{

    if (!this._authService.isLoggedIn()) return of(null);
    const url = `${environment.apigee.host}/external/microsoft/graph/v1/me`;
    const query = `$select=employeeId`
    const requestOption = {
      method: "GET",
      headers: new HttpHeaders({
        "Authorization": `Bearer ${this._authService?.accessToken?.accessToken}`,
        "skip": "true"
      })
    };
    return this._httpClient.get<IMSGraphResponse>(this._baseUrl, requestOption);
  }
}
